export { default } from "../objectWithoutProperties/_index.mjs"